import { render, staticRenderFns } from "./ToolbarLanguage.vue?vue&type=template&id=9df17842"
import script from "./ToolbarLanguage.vue?vue&type=script&lang=js"
export * from "./ToolbarLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9df17842')) {
      api.createRecord('9df17842', component.options)
    } else {
      api.reload('9df17842', component.options)
    }
    module.hot.accept("./ToolbarLanguage.vue?vue&type=template&id=9df17842", function () {
      api.rerender('9df17842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/toolbar/ToolbarLanguage.vue"
export default component.exports